import React, { useEffect } from "react";
import { Backtotop, Floatinmenu, Underline } from "../../widgets";
import { RadialMenu, Table } from "../../components";
import {
  librarymenu,
  privilegescolumn,
  privilegesvalues,
} from "../../constants/library";
import { FaBook } from "react-icons/fa";
import "./Library.css";
import "../Library/Privileges.css";
export default function Privileges() {
  useEffect(() => {
    document.title = "ACCET-Library | Privileges of Members";
  }, []);

  return (
    <>
      <div className="librarypage">
        <div className="librarybg">
          <div className="libraryheading">Library</div>
          <div className="library_sub_heading">Previleges</div>
        </div>
      </div>
      <section className="librarydark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaBook} head="Menu" links={librarymenu} />
        </div>
        <RadialMenu menu_links={librarymenu} />
        <Underline heading="Privileges of Members"></Underline>
        <div className="privileges_tab">
          <Table data={privilegesvalues} columns={privilegescolumn} />
        </div>

        <Underline heading="Book Bank" />
        <div className="Book-Lost-Content">
          <p>
            The Book Bank facility is available exclusively for SC/ST students
            (UG/PG). Eligible students may borrow up to 6 books per semester.
            The return period is set for each semester, and no fines will be
            imposed for regular borrowing within this period.
          </p>
        </div>
        <Underline heading="Book Lost" />
        <div className="Book-Lost-Content">
          <p>
            In the event of a lost book, members are required to replace it with
            a new copy of the latest edition. If replacement is not possible,
            the cost recovery will be as follows: double the cost of the book if
            purchased within the last 8 years, or triple the cost if purchased
            earlier. The applicable fine will be charged until the date of
            replacement or settlement.
          </p>
        </div>
      </section>
      <Backtotop />
    </>
  );
}
